import { countries } from "../../../data/countries";
import { provinces } from "../../../data/province";
import { states } from "../../../data/states";

export const countryList = countries.map(country => {
  return country.value;
}).concat(['US', 'USA']).toString().replaceAll(',', '|');

const stateList = states.concat(provinces).map(state => {
  return state.value;
}).toString().replaceAll(',', '|');

export const spreadsheetImportFields = [
  {
    label: 'Type',
    key: 'Type',
    fieldType: {
      type: 'input'
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Type is required.'
      },
      {
        rule: 'regex',
        errorMessage: 'Invalid value (must be Primary, Spouse or Child)',
        value: '^(Primary|Spouse|Child)$'
      }
    ]
  },
  {
    label: 'First Name',
    key: 'First Name',
    fieldType: {
      type: 'input'
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'First name is required.'
      }
    ]
  },
  {
    label: 'Last Name',
    key: 'Last Name',
    fieldType: {
      type: 'input'
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Last name is required.'
      }
    ]
  },
  {
    label: 'Date of Birth',
    key: 'Date of Birth',
    fieldType: {
      type: 'input'
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Date of birth is required.'
      },
    ]
  },
  {
    label: 'Gender',
    key: 'Gender',
    fieldType: {
      type: 'input',
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Gender is required.'
      },
      {
        rule: 'regex',
        errorMessage: 'Invalid value (must be M/Male or F/Female)',
        value: /^(M|Male|F|Female)$/i
      }
    ]
  },
  {
    label: 'Country of Citizenship',
    key: 'Country of Citizenship',
    fieldType: {
      type: 'input',
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Country of citizenship is required.'
      },
      {
        rule: 'regex',
        errorMessage: 'Invalid value (must a value from the list of country abbreviations)',
        value: `^(${countryList})$`
      }
    ]
  },
  {
    label: 'Country of Residence',
    key: 'Country of Residence',
    fieldType: {
      type: 'input',
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'Country of residence is required.'
      },
      {
        rule: 'regex',
        errorMessage: 'Invalid value (must a value from the list of country abbreviations)',
        value: `^(${countryList})$`
      }
    ]
  },
  {
    label: 'State / Province',
    key: 'State / Province',
    fieldType: {
      type: 'input',
    },
    validations: [
      {
        rule: 'required',
        errorMessage: 'State/province is required.'
      },
      {
        rule: 'regex',
        errorMessage: 'Invalid value (must an abbreviation from the list of states and provinces)',
        value: `^(${stateList})$`
      }
    ]
  },
  {
    label: 'Trip Cost',
    key: 'Trip Cost',
    fieldType: {
      type: 'input',
    }
  },
  {
    label: 'Start Date',
    key: 'Start Date',
    fieldType: {
      type: 'input',
    }
  },
  {
    label: 'End Date',
    key: 'End Date',
    fieldType: {
      type: 'input',
    }
  },
  {
    label: 'Email',
    key: 'Email',
    fieldType: {
      type: 'input',
    },
  },
]